import {isNotNilOrEmpty} from 'ramda-adjunct';

import {GetDirectSaleDiscountResponse} from '@dms/api/warehouse';

/**
 * Determines whether the direct-sale discount response carries a *real* work discount.
 *
 * The backend materializes `workDiscount` with zeroed defaults (`percentageDiscount: 0`,
 * `discountedWorkRate: []`) after any save — even when only the material discount was set. A plain
 * `isNotNil` check therefore treats those defaults as a discount and wrongly expands the "Discount
 * on work" section after saving a material-only discount (T20-131051). Mirror the semantics of
 * getWorkDiscountDefaults: a work discount exists only for a non-empty work-rate list or a non-zero
 * percentage.
 */
export function hasWorkDiscount(
  workDiscount: GetDirectSaleDiscountResponse['workDiscount'] | undefined
): boolean {
  return (
    isNotNilOrEmpty(workDiscount?.discountedWorkRate) ||
    (workDiscount?.percentageDiscount ?? 0) !== 0
  );
}
